import { type KeyboardEvent } from 'react'
import { observer } from 'mobx-react-lite'
import { type Observable } from 'rxjs'
import { type SelectQuestionAnswerEditorViewModel } from '@/features/jobs/questions/select/SelectQuestionAnswerEditorViewModel'
import { SimpleSelect } from '@/features/jobs/questions/select/components/SimpleSelect'

export interface SimpleSelectContainerProps {
  editorVm: SelectQuestionAnswerEditorViewModel
  questionId: string
  isDisabled: boolean
  focus$?: Observable<unknown>
  onFocus?: () => unknown
  onEnterDown?: (e: KeyboardEvent) => unknown
  isNotValid?: boolean
}

export const SimpleSelectContainer = observer(function SimpleSelectContainer({
  editorVm,
  questionId,
  ...rest
}: SimpleSelectContainerProps) {
  return (
    <SimpleSelect
      multi={editorVm.multi}
      options={editorVm.options}
      selectedIds={editorVm.selected.map((s) => s.id)}
      onToggleOption={editorVm.toggleOption}
      optionTestIdPrefix={`select-answer-${questionId}`}
      {...rest}
    />
  )
})
